import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyChoVayApi from "service/quanLyThuChiApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import ReactToPrint from "react-to-print";
import ReactDropdown from "react-dropdown";
import CongNoThanhLyApi from "service/congNoThanhLyApi";
import ChiTietHopDongApi from "../../../../../service/chiTietHopDongApi";
import InChoVayApi from "service/inChoVayApi";
export const ModalPhieuThu = (props) => {
  const scrollRef = useRef();

  const [hopdong, setDataHopDong] = useState({});
  const [ListMauPhieuIn, setListMauPhieuIn] = useState({});
  const [keyMauIn, setKeyMauIn] = useState("");
  const ChiTietHopDong = () => {
    ChiTietHopDongApi.getChiTietHopDong1(props.hopdongId).then((response) => {
      setDataHopDong(response.data);
    });
  };
  const dataInit = {
    // Name: "",
    // Value: "",
    // UpdatedTime: "",
    // CreatedTime: "",
    // CreatedUser: "",
    // UserName: "",
    // Note: "",
    // NoteDefault: "",
    // Code: "",
    // MaChungTu: "",

    AdminApprove: 0,
    Amercement: 0,
    Code: "",
    CreatedTime: "",
    CreatedUser: "",
    IsDelete: "",
    LoaiThuChiNgoaiLe: "",
    MaChungTu: "",
    Name: "",
    Note: "",
    NoteDefault: "",
    NoteDeleted: "",
    OtherFee: 0,
    PhiHoaHongTraGop: 0,
    PhiKho: 0,
    ShopDoiTacId: 0,
    Status: 0,
    ThuChiCode: "",
    ThuChiId: 0,
    Time: "",
    Type: 0,
    UpdatedTime: "",
    UpdatedUser: "",
    UserName: "",
    Value: 0,
  };
  const [dataChiTietThuChi, UpdateDataChiTietThuChi] = useState(dataInit);

  const dataIn = {
    printContent: "",
  };
  const [dataInThu, UpdateDataInThu] = useState(dataIn);

  const ChiTietThuChi = () => {
    QuanLyChoVayApi.chiTietThuChi(props.id).then((response) => {
      UpdateDataChiTietThuChi(response.data);
      getComboMauIn(response.data.Type);
    });
  };

  const InPhieuThu = (keyIn) => {
    InChoVayApi.getInThuChi1(props.id, keyIn).then((response) => {
      UpdateDataInThu({
        ...dataInThu,
        printContent: response.data,
      });
    });
  };

  const getComboMauIn = (type) => {
    InChoVayApi.comboMauPhieuThuChi(type).then((response) => {
      if (response.data.List) {
        console.log(response.data.List, "response.data.List");
        setListMauPhieuIn(response.data.List);
        setKeyMauIn(response.data.List[0].value);
        InPhieuThu(response.data.List[0].value);
      }
    });
  };
  const onChangeMauIn = () => (item) => {
    setKeyMauIn(item.value);
    InPhieuThu(item.value);
  };

  // console.log(dataChiTietThuChi);
  useEffect(() => {
    ChiTietHopDong();
    ChiTietThuChi();
    //InPhieuThu();
    return () => {
      UpdateDataChiTietThuChi({}); // This worked for me ** fix: To fix, cancel all subscriptions and asynchronous tasks in a use Effect cleanup function
    };
  }, []);

  const ComponentToPrint = React.forwardRef((props, ref) => (
    <div
      className="col-sm-12"
      style={{ width: "100%", color: "#000000" }}
      ref={ref}
    >
      <div
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{ __html: props.data }}
      ></div>
    </div>
  ));

  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-bookmark-multiple-outline"></i>
          </span>
          Thông tin phiếu thu
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253"
                className="card-header border-info"
                href="#collapse253"
                aria-expanded="true"
                aria-controls="collapse253"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Chi tiết</h3>
                </a>
              </div>
              <div className="card-collapse collapse show">
                <div className="card-content">
                  <div className="card-body">
                    <div className="form-body form-bordered-1">
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Người nộp
                        </label>
                        <div className="col-md-9">{dataChiTietThuChi.Name}</div>
                      </div>
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput2"
                        >
                          Số tiền thu
                        </label>
                        {props.CVType === 3 && (
                          <div className="col-md-9">
                            Tiền thu: {formatNumber(dataChiTietThuChi.Value)} -
                            Phí khác: {formatNumber(dataChiTietThuChi.OtherFee)}{" "}
                            - Phí kho:{" "}
                            {formatNumber(dataChiTietThuChi.OtherFee)}
                            {dataChiTietThuChi.PhiPhatDongLai != undefined &&
                              dataChiTietThuChi.PhiPhatDongLai > 0 && (
                                <span>
                                  {" "}
                                  - Phạt chậm đóng lãi :{" "}
                                  {formatNumber(
                                    dataChiTietThuChi.PhiPhatDongLai
                                  )}
                                </span>
                              )}
                            {dataChiTietThuChi.PhiPhatTatToan != undefined &&
                              dataChiTietThuChi.PhiPhatTatToan > 0 && (
                                <span>
                                  {" "}
                                  - Phạt tất toán sớm :{" "}
                                  {formatNumber(
                                    dataChiTietThuChi.PhiPhatTatToan
                                  )}
                                </span>
                              )}
                          </div>
                        )}
                        {props.CVType === 1 && (
                          <div className="col-md-9">
                            Tiền thu: {formatNumber(dataChiTietThuChi.Value)} -
                            Phí khác: {formatNumber(dataChiTietThuChi.OtherFee)}{" "}
                            - Phí kho:{" "}
                            {formatNumber(dataChiTietThuChi.OtherFee)}
                            {dataChiTietThuChi.PhiPhatDongLai != undefined &&
                              dataChiTietThuChi.PhiPhatDongLai > 0 && (
                                <span>
                                  {" "}
                                  - Phạt chậm đóng lãi :{" "}
                                  {formatNumber(
                                    dataChiTietThuChi.PhiPhatDongLai
                                  )}
                                </span>
                              )}
                            {dataChiTietThuChi.PhiPhatTatToan != undefined &&
                              dataChiTietThuChi.PhiPhatTatToan > 0 && (
                                <span>
                                  {" "}
                                  - Phạt tất toán sớm :{" "}
                                  {formatNumber(
                                    dataChiTietThuChi.PhiPhatTatToan
                                  )}
                                </span>
                              )}
                          </div>
                        )}
                        {props.CVType === 2 && (
                          <div className="col-md-9">
                            Tiền thu: {formatNumber(dataChiTietThuChi.Value)}
                            {dataChiTietThuChi.PhiPhatDongLai != undefined &&
                              dataChiTietThuChi.PhiPhatDongLai > 0 && (
                                <span>
                                  {" "}
                                  - Phạt chậm đóng lãi :{" "}
                                  {formatNumber(
                                    dataChiTietThuChi.PhiPhatDongLai
                                  )}
                                </span>
                              )}
                            {dataChiTietThuChi.PhiPhatTatToan != undefined &&
                              dataChiTietThuChi.PhiPhatTatToan > 0 && (
                                <span>
                                  {" "}
                                  - Phạt tất toán sớm :{" "}
                                  {formatNumber(
                                    dataChiTietThuChi.PhiPhatTatToan
                                  )}
                                </span>
                              )}
                          </div>
                        )}
                        {props.CVType === 4 ||
                          (props.CVType === null && (
                            <div className="col-md-9">
                              Tiền thu: {formatNumber(dataChiTietThuChi.Value)}
                            </div>
                          ))}
                      </div>
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput3"
                        >
                          Ngày thu
                        </label>
                        <div className="col-md-9">
                          {getDate(dataChiTietThuChi.Time)}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput3"
                        >
                          Thời gian tạo
                        </label>
                        <div className="col-md-9">
                          {dataChiTietThuChi.CreatedTime}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Người tạo
                        </label>
                        <div className="col-md-9">
                          {dataChiTietThuChi.CreatedUser}
                        </div>
                      </div>

                      <div className="form-group row">
                        {props.CVType === 4 ||
                          (props.CVType === null ? (
                            <label
                              className="col-md-3 label-control"
                              for="projectinput1"
                            >
                              Mã nhận vay
                            </label>
                          ) : (
                            <label
                              className="col-md-3 label-control"
                              for="projectinput1"
                            >
                              Mã cho vay
                            </label>
                          ))}
                        <div className="col-md-9">{dataChiTietThuChi.Code}</div>
                      </div>
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Chi tiết
                        </label>
                        {props.CVType === 3 && (
                          <div className="col-md-9">
                            Ngày vay: {getDate(hopdong.CreatedTime)} - Tiền vay:{" "}
                            {formatNumber(hopdong.Sotienvay)}
                          </div>
                        )}
                        {props.CVType === 1 && (
                          <div className="col-md-9">
                            Ngày vay: {getDate(hopdong.CreatedTime)} - Tiền vay:{" "}
                            {formatNumber(hopdong.Sotienvay)} - Tín Chấp - Lãi
                            suất: 1
                          </div>
                        )}
                        {props.CVType === 2 && (
                          <div className="col-md-9">
                            Ngày vay: {getDate(hopdong.CreatedTime)} - Tiền vay:{" "}
                            {formatNumber(hopdong.Sotienvay)} - Trả góp - Lãi
                            suất: 1
                          </div>
                        )}
                        {props.CVType === 4 ||
                          (props.CVType === null && (
                            <div className="col-md-9">
                              Ngày vay: {getDate(hopdong.CreatedTime)} - Tiền
                              nhận vay: {formatNumber(hopdong.Sotienvay)} - Lãi
                              suất: 1
                            </div>
                          ))}
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput2"
                        >
                          Tên khách hàng
                        </label>
                        {props.CVType === 4 ||
                          (props.CVType === null && (
                            <label
                              className="col-md-3 label-control"
                              for="projectinput2"
                            >
                              Tên chủ nợ
                            </label>
                          ))}
                        <div className="col-md-9">{hopdong.CustomerName}</div>
                      </div>
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput2"
                        >
                          Ngày sinh
                        </label>
                        <div className="col-md-9">
                          {getDate(hopdong.Birthday)}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput2"
                        >
                          Địa chỉ
                        </label>
                        <div className="col-md-9">{hopdong.addressCus}</div>
                      </div>
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput2"
                        >
                          Người thu
                        </label>
                        <div className="col-md-9">
                          {dataChiTietThuChi.UserName}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Ghi chú
                        </label>
                        <div className="col-md-9">{dataChiTietThuChi.Note}</div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput3"
                        >
                          Nội dung
                        </label>
                        {dataChiTietThuChi.Type === 1 && (
                          <div className="col-md-9">Kỳ lãi</div>
                        )}
                        {dataChiTietThuChi.Type === 11 && (
                          <div className="col-md-9">Tất toán</div>
                        )}
                        {dataChiTietThuChi.Type === 17 && (
                          <div className="col-md-9">Trả bớt gốc</div>
                        )}
                        {dataChiTietThuChi.Type === 21 && (
                          <div className="col-md-9">Vay thêm</div>
                        )}
                        {dataChiTietThuChi.Type === 2 && (
                          <div className="col-md-9">Chi cho vay</div>
                        )}
                        {dataChiTietThuChi.Type === 4 && (
                          <div className="col-md-9">Thu nhận vay</div>
                        )}
                        {dataChiTietThuChi.Type === 24 && (
                          <div className="col-md-9">Thu phí khác</div>
                        )}
                        {dataChiTietThuChi.Type === 16 && (
                          <div className="col-md-9">
                            Thu phí thanh lý tài sản
                          </div>
                        )}
                        {dataChiTietThuChi.Type === 30 && (
                          <div className="col-md-9">Chi hoa hồng</div>
                        )}
                      </div>
                      {props.CVType === 2 && (
                        <div className="form-group row">
                          <label
                            className="col-md-3 label-control"
                            for="projectinput1"
                          >
                            Kênh thanh toán
                          </label>
                          <div className="col-md-9">fasdf</div>
                        </div>
                      )}
                    </div>
                    <div style={{ display: "none" }}>
                      <ComponentToPrint
                        data={dataInThu.printContent}
                        ref={scrollRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        {/* <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={deleteCongNoThanhLy()}
        >
          <span className="btn-icon-left">
            <i className="fas fa-print"></i>
          </span>{" "}
          In phiếu
        </a> */}
        {props.inPhieuThu && (
          <>
            <div class="col-sm-3">
              <ReactDropdown
                onChange={onChangeMauIn()}
                options={ListMauPhieuIn}
                controlClassName="form-control input-sm"
                value={keyMauIn}
              />
            </div>
            <ReactToPrint
              trigger={() => {
                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                // to the root node of the returned component as it will be overwritten.
                return (
                  <a class="btn btn-new-main btn-checknew" href={() => false}>
                    <span class="btn-icon-left">
                      <i class="mdi mdi-printer"></i>
                    </span>{" "}
                    In phiếu
                  </a>
                );
              }}
              content={() => scrollRef.current}
              copyStyles={false}
            />
          </>
        )}

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
